import { css } from '@emotion/css';

export const linkButtonStyles = css`
  border-radius: 0.6rem !important;
`;

export const assignButtonStyles = css`
  padding-inline-start: 0.6rem;
  padding-inline-end: 1rem;
`;

export const disabledButtonStyles = css`
  opacity: 1 !important;
`;
